module.exports = __webpack_public_path__ + "static/functions-screen-10-05c35039d5d5fbf020c99e125ace22ba.png";